import { declareRoute } from "utilities/routes/route.utility";

/**
 * The full-page Ask experience. The question rides in the query string rather
 * than router state, so an answer survives a refresh and can be linked to.
 */
export const searchAskRoute = declareRoute("/Ask");

/**
 * The Ask page's query-string key for the record a handed-over question is
 * about, as `kind:id`. Captured in the dialog, because by the time the page
 * loads the location no longer says what the user had open.
 */
export const ASK_RECORD_PARAM = "record";
